
import Swiper from 'vux/src/components/swiper/swiper.vue'


export default {
components: {
Swiper
},
methods: {},
mounted() {},
computed: {
getBanner() {
let arr = this.banner;
var bannerArr = [];
for (let i = 0; i < arr.length; i++) {
bannerArr.push({
img: this.UPLOAD_DOMAIN + arr[i].image,
title: arr[i].title,
url: arr[i].url
})
};
return bannerArr;
}
},
props: ['banner'],
data() {
return {}
}
}



// WEBPACK FOOTER //
// ./src/components/Home/swiper.vue